export default __webpack_public_path__ + "assets/parking-indoor/tallinn-telliskivi-entrance.03a936c61aec315ec40a34087041d0d9.webp";